module.exports = __webpack_public_path__ + "img/logo9.8791ffbe.png";